import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { NavLink } from "react-router-dom";

type Props = PropsWithChildren & {
	className?: string;
	to: string;
}

const InvoiceDetailsLink = ({ children, className, to }: Props) => (
	<NavLink
		to={to}
		className={clsx("truncate transition-colors duration-200 hover:text-secondary-500", className)}
	>
		{children}
	</NavLink>
);

export default InvoiceDetailsLink;